<template>
<div class="chapter">
<div class="inner_page">
<h1>With Washington</h1>
<h1 class="sigil_not_in_toc">In the West,</h1>
<h4 class="sigil_not_in_toc">Or, A Soldier Boy's Battles the Wilderness</h4>
<h2 class="sigil_not_in_toc">Edward Stratemeyer</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?0f18b914